import { DEFAULT_PUBLIC_API_ORIGIN } from "@/lib/api/backendUrls"

/**
 * База API: prod — `VITE_API_BASE_URL` или DEFAULT_PUBLIC_API_ORIGIN.
 * В dev по умолчанию тот же origin, что и в бандле (запросы с браузера), чтобы не зависеть от TLS Vite-прокси (VPN и т.п.).
 * Вернуть прокси: `VITE_DEV_USE_VITE_PROXY=1` или задать только `VITE_API_BASE_URL` как нужно.
 */
export const getApiBaseUrl = () => {
  const fromEnv = import.meta.env.VITE_API_BASE_URL as string | undefined
  if (fromEnv !== undefined && fromEnv !== "") {
    return fromEnv.replace(/\/$/, "")
  }
  if (import.meta.env.DEV) {
    const useViteProxy =
      import.meta.env.VITE_DEV_USE_VITE_PROXY === "1" ||
      import.meta.env.VITE_DEV_USE_VITE_PROXY === "true"
    if (useViteProxy) return ""
  }
  return DEFAULT_PUBLIC_API_ORIGIN
}

export const buildApiUrl = (path: string) => {
  const apiBase = getApiBaseUrl()
  const p = path.startsWith("/") ? path : `/${path}`
  if (apiBase !== "") {
    return `${apiBase.replace(/\/$/, "")}${p}`
  }
  /** При деплое с `BASE_PATH` (не `/`) относительные `/api` и `/connect` должны идти под тем же префиксом. */
  const rawViteBase = import.meta.env.BASE_URL || "/"
  const basePath = rawViteBase === "/" ? "" : rawViteBase.replace(/\/$/, "")
  if (basePath && (p.startsWith("/api/") || p.startsWith("/connect/"))) {
    return `${basePath}${p}`
  }
  return p
}
